import React from "react";
import { Row, Col } from "react-bootstrap";
import { Cache } from "aws-amplify";

import {
  PROJECT_ADMIN,
  PROJECT_SPONSOR,
  PORTAL_ADMIN,
  FINANCE_APPROVER,
  EMPLOYEE,
  TEAM_LEADER,
} from "../../store/actions/users/usersActions";

import ProjectDetails from "./ProjectDetails";
import ProjectMembers from "./ProjectMembers";
import ProjectCosting from "./ProjectCosting";

export default function CompleteDetails({
  project,
  newDetails,
  oldDetails,
  forApproval = false,
  fromViewProj = false,
}) {
  const displayProjectDetails = () => {
    return (
      <Row className={fromViewProj ? "mt-3" : "mt-5"}>
        <Col>
          <ProjectDetails
            project={project}
            newDetails={newDetails}
            oldDetails={oldDetails}
            readOnly={true}
            forApproval={forApproval}
          />
        </Col>
      </Row>
    );
  };

  const displayProjectMembers = () => {
    const roleId = Cache.getItem("roleId");

    if (roleId === EMPLOYEE || roleId === TEAM_LEADER) {
      return "";
    }

    return (
      <Row className="mt-5">
        <Col>
          <ProjectMembers
            project={project}
            readOnly={true}
            forApproval={forApproval}
          />
        </Col>
      </Row>
    );
  };

  const displayProjectCosting = () => {
    const roleId = Cache.getItem("roleId");

    if (
      roleId !== PROJECT_SPONSOR &&
      roleId !== PORTAL_ADMIN &&
      roleId !== FINANCE_APPROVER &&
      roleId !== PROJECT_ADMIN
    ) {
      return "";
    }

    return (
      <Row className="mt-5">
        <Col>
          <ProjectCosting
            project={project}
            newDetails={newDetails}
            oldDetails={oldDetails}
            readOnly={true}
            forApproval={forApproval}
          />
        </Col>
      </Row>
    );
  };

  return (
    <>
      {displayProjectDetails()}
      {displayProjectMembers()}
      {displayProjectCosting()}
    </>
  );
}
